export default __webpack_public_path__ + "static/media/xcDOT.71eafc2f.png";